var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 146,
    viewBox: "0 0 189 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.786 124.811L186.278 137.917C187.938 140.117 186.551 143.5 183.994 143.5H6.62266C2.67527 143.5 0.548484 138.262 3.13042 134.885L17.9807 114.556L169.33 115.476C169.33 115.476 169.33 39.0816 169.33 12.4268C169.33 7.43225 165.743 3.38148 161.32 3.38148H78.048C68.5602 3.38148 41.6319 3.56836 37.6804 3.38148C32.2517 3.12451 26.9554 0.755714 22.1391 5.05411C15.5105 10.9738 17.9807 23.9717 17.9807 32.4471V89.812C17.9807 94.4655 21.324 98.2406 25.4451 98.2406C34.3288 98.2406 42.4429 98.0865 50.9542 94.4468C56.4532 92.0967 61.6336 88.2469 64.7949 82.6449C66.0693 80.3836 67.0168 77.641 66.3962 75.0526C65.6721 72.0437 62.9246 70.0627 60.1772 69.7684C54.7154 69.1844 49.6218 74.6508 48.9722 80.7994C48.3185 86.9527 51.488 93.1106 56.0601 96.5353C60.6323 99.96 66.3672 100.946 71.8373 100.474C77.3073 100.002 82.6078 98.1752 87.8502 96.3577",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseHeaderIcon);
export default __webpack_public_path__ + "static/media/course-header-icon.5a26e2a085b6c4cc794614d2d5f14178.svg";
export { ForwardRef as ReactComponent };